import { get, put, postFormData } from '../apiService';
import type { Game } from '../../types/content/game';

export async function getGameByCourseId(courseId: string): Promise<Game> {
  return get<Game>(`/course/${courseId}/game?expand=scenarios,finalResults,scoreMeter,prospectProfile,timelineStages`);
}

export async function updateGame(id: string, data: Game): Promise<Game> {
  return put<Game>(`/game/${id}`, data);
}

export async function uploadGameImage(gameId: string, formData: FormData): Promise<{ url: string }> {
  return postFormData<{ url: string }>(`/game/${gameId}/image`, formData);
}
